// extracted by mini-css-extract-plugin
export default {"familyHisContainer":"FamilyHistory_familyHisContainer__ZDgHt","radioBtnContainer":"FamilyHistory_radioBtnContainer__9kFfQ","radioBtn":"FamilyHistory_radioBtn__kug1g"};